// frontend/packages/business-console/src/components/media/MediaGrid.jsx

import React from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import MediaCard from "./MediaCard";

export default function MediaGrid({
  loading,
  items,
  onSelect,
  onOpenDetails,
  selectedId,
  onDoubleClick,
  // Multi-select (library page): when selectable, a card click toggles it.
  selectable = false,
  selectedIds,
  onToggleSelect,
}) {
  if (loading) {
    return (
      <Box sx={{ py: 4, display: "flex", alignItems: "center", gap: 1 }}>
        <CircularProgress size={18} />
        <Typography variant="body2" sx={{ opacity: 0.75 }}>
          Loading media…
        </Typography>
      </Box>
    );
  }

  if (!items?.length) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="body2" sx={{ opacity: 0.75 }}>
          No media found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(3, minmax(0, 1fr))",
          md: "repeat(4, minmax(0, 1fr))",
        },
        gap: 2,
      }}
    >
      {items.map((item) => {
        const id = item?.id || item?._id || "";
        const checked = Boolean(selectable && selectedIds?.has(id));
        const selected = checked || (selectedId && id === selectedId);

        return (
          <Paper
            key={id || item?.publicUrl || item?.blobPath}
            variant="outlined"
            sx={{
              borderColor: selected ? "primary.main" : "divider",
              boxShadow: selected ? 2 : 0,
            }}
          >
            <MediaCard
              asset={item}
              onClick={() =>
                selectable ? onToggleSelect?.(item) : onSelect?.(item)
              }
              selectable={selectable}
              checked={checked}
              onToggleSelect={() => onToggleSelect?.(item)}
              onDoubleClick={() => onDoubleClick?.(item)}
              onOpenDetails={() => onOpenDetails?.(item)}
            />
          </Paper>
        );
      })}
    </Box>
  );
}